import * as actions from './actions'
import * as getters from './getters'
import { STEP_STATUS_VALUE, STEP_STATUS } from '@/config/constants'

const state = {
  stepsInfo: [
    { name: '商品信息', value: STEP_STATUS_VALUE.goodInfo, status: STEP_STATUS.default },
    { name: '售卖信息', value: STEP_STATUS_VALUE.sellInfo, status: STEP_STATUS.default },
    { name: '发票信息', value: STEP_STATUS_VALUE.invoiceInfo, status: STEP_STATUS.default }
  ],
  submitInfo: {
    step: 0, // 当前步骤
    goodInfo: {}, // 商品信息
    sellInfo: {}, // 售卖信息
    invoiceInfo: { } // 发票信息
  },
  active: 3, // 当前点击步骤
  stepComplete: [] // 步骤完成情况
}
const mutations = {
  // 更新步骤状态
  updateStepStatus(state, { index, status }) {
    if (index >= 0 && index < state.stepsInfo.length) {
      // 更新指定步骤的状态
      state.stepsInfo[index].status = status

      // 如果是成功状态，确保之前的步骤也是成功状态
      if (status === 'success') {
        for (let i = 0; i < index; i++) {
          state.stepsInfo[i].status = 'success'
        }
      }
    }
  },

  // 更新提交信息
  updateSubmitInfo(state, { step, data }) {
    switch (step) {
      case STEP_STATUS_VALUE.goodInfo:
        state.submitInfo.goodInfo = data
        break
      case STEP_STATUS_VALUE.sellInfo:
        state.submitInfo.sellInfo = data
        break
      case STEP_STATUS_VALUE.invoiceInfo:
        state.submitInfo.invoiceInfo = data
        break
    }
    state.submitInfo.step = step
  },

  // 更新当前活动步骤
  UPDATE_ACTIVE(state, active) {
    state.active = active
  },

  // 更新步骤完成情况
  updateStepComplete(state, step) {
    if (!state.stepComplete.includes(step)) {
      state.stepComplete.push(step)
    }
  },
  /**
   * @function 设置进度信息
   * @param stepInfo 步骤信息
   * @param type 类型
   * @param isHasEdit 是否可编辑
   * @param submitStep 提交到哪一步
   * @param isReject 是否被驳回
   */
  setStepInfo(state, { stepInfo, type, isHasEdit, submitStep, isReject }) {
    console.log('store - 设置步骤条状态-->', {
      stepInfo,
      type,
      submitStep,
      isReject
    })

    // 如果是驳回状态，根据 submitStep 设置对应步骤的状态
    if (isReject) {
      state.stepsInfo = state.stepsInfo.map((step, index) => {
        if (index < submitStep) {
          return { ...step, status: STEP_STATUS.success }
        } else if (index === submitStep) {
          return { ...step, status: STEP_STATUS.error }
        } else {
          return { ...step, status: STEP_STATUS.edit }
        }
      })
      return
    }

    switch (type) {
      case 'reject':
        state.stepsInfo.forEach(i => {
          i.status = i.value <= stepInfo ? STEP_STATUS.success : STEP_STATUS.error
        })
        break
      case 'success':
        state.stepsInfo[stepInfo - 1].status = STEP_STATUS.success
        if (isHasEdit) {
          state.stepsInfo[stepInfo].status = STEP_STATUS.edit
        }
        break
      case 'editing':
        state.stepsInfo[stepInfo].status = STEP_STATUS.edit
        state.stepsInfo[stepInfo - 1].status = STEP_STATUS.edit
        break
      default:
        state.stepsInfo[stepInfo - 1].status = STEP_STATUS.edit
        break
    }
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}
